import axios from '@/utils/axiosHelper';

// 召回 绑定队友
export const recallBindPlayerAPI = (data) => {
  return axios({ url: '/snail/spring/topic/invite/entry', method: 'POST', data }, { interceptResultCode: false });
}

// 字牌初始化
export const onGetInitLightDataAPI = (params) => {
  return axios({ url: '/snail/spring/topic/card', method: 'GET', params }, { interceptResultCode: false });
};

// 字牌分享码初始化
export const onGetInitLightCodeAPI = (data) => {
  return axios({ url: '/snail/spring/topic/code', method: 'POST', data }, { interceptResultCode: false });
};
// 字牌刷新数据
export const onGetInitLighiDataRefreshAPI = (data) => {
  return axios({ url: '/snail/spring/topic/refresh', method: 'POST', data }, { interceptResultCode: false });
};
// 领取字牌初始化
export const onGetInitLightHelpDataAPI = (data) => {
  return axios({ url: '/snail/spring/topic/card/help', method: 'GET', data }, { interceptResultCode: false });
};
// 接受字牌
export const onGetInitLightGetAPI = (data) => {
  return axios({ url: '/snail/spring/topic/get', method: 'POST', data }, { interceptResultCode: false });
};

// 获取服务器时间
export const onGetTimeAPI = (params) => {
  return axios({ url: '/snail/year/show', method: 'GET', params }, { interceptResultCode: false });
};


// WEBPACK FOOTER //
// ./src/pages/snail/wordHunt/light/api.js